$(function () {
  
  // window.onscroll = () => {
  //   checkImgs()
  // }

  // function checkImgs () {
  //   const videos = $(".box7")
  //   if (isInViewPortOfOne(videos[0])) loadImg()
  // }

  // function loadImg() {
  //   // const video7 = document.querySelector('#video7')
  //   // const video8 = document.querySelector('#video8')
  //   const video9 = document.querySelector('#video9')
  //   const video10 = document.querySelector('#video10')
 
  //   // if (!video7.currentSrc) {
  //   //   video7.src = video7.getAttribute('data-src')
  //   // }
  //   // if (!video8.currentSrc) {
  //   //   video8.src = video8.getAttribute('data-src')
  //   // }
  //   if (!video9.currentSrc) {
  //     video9.src = video9.getAttribute('data-src')
  //   }
  //   if (!video10.currentSrc) {
  //     video10.src = video10.getAttribute('data-src')
  //   }
  //   // 这里应该是有一个优化的地方，设一个标识符标识已经加载图片的index，当滚动条滚动时就不需要遍历所有的图片，只需要遍历未加载的图片即可。
  // }

  // function isInViewPortOfOne (el) {
  //   // viewPortHeight 兼容所有浏览器写法
  //   const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight 
  //   const offsetTop = el.offsetTop
  //   const scrollTop = document.documentElement.scrollTop
  //   const top = offsetTop - scrollTop
  //   // console.log('top', top)
  //   // 这里有个+100是为了提前加载+ 100
  //   return top <= viewPortHeight + 100
  // }

  // video9.setAttribute('src',video9.dataset.src)
  // video10.setAttribute('src',video10.dataset.src)
  

  $('.video-but-mp4').click(function() {
    const index = $(this).index()
    const videoWidth = $(this).context.dataset.width;
    const videoHeight = $(this).context.dataset.height;
    const videoSrc = $(this).context.dataset.src;

    $(this).parent().css('display', 'none')

    let videoCode = `
<video width="${videoWidth}" height="${videoHeight}" controls="controls" autoplay="autoplay" >
  <source src="${videoSrc}" />
  <source src="movie.ogg" type="video/ogg" />
  Your browser does not support the video tag.
</video>
`

    $(this).parent().next().append(videoCode)

  })


  $('.buy-now').click(()=>{
    $('#tab').click()
  })

  
})